<template>
  <div class="doc-section">
    <div class="section-header">
      <span class="material-icons-sharp section-icon">login</span>
      <h2>Connexion au système</h2>
    </div>

    <p class="section-intro">
      L'accès au système est sécurisé par authentification. Chaque utilisateur
      dispose d'un compte personnel créé par l'administrateur, avec un email et un mot de passe.
    </p>

    <h3 class="sub-title">Champs du formulaire de connexion</h3>
    <div class="table-wrapper">
      <table>
        <thead>
          <tr><th>Champ</th><th>Type</th><th>Obligatoire</th><th>Ce qu'il faut saisir</th></tr>
        </thead>
        <tbody>
          <tr>
            <td><strong>Email</strong></td>
            <td>Texte</td>
            <td><span class="required-badge badge-yes">Oui</span></td>
            <td>Votre adresse email professionnelle (identifiant unique). Exemple : jean.dupont@abiaphar.com</td>
          </tr>
          <tr>
            <td><strong>Mot de passe</strong></td>
            <td>Texte masqué</td>
            <td><span class="required-badge badge-yes">Oui</span></td>
            <td>Votre mot de passe. Les caractères sont masqués par des points pour la sécurité.</td>
          </tr>
        </tbody>
      </table>
    </div>

    <h3 class="sub-title">Procédure de connexion pas à pas</h3>
    <div class="steps">
      <div class="step-item">
        <div class="step-num">1</div>
        <p><strong>Ouvrir la page</strong> — Accédez à l'adresse du système dans votre navigateur. La page de connexion s'affiche avec deux champs.</p>
      </div>
      <div class="step-item">
        <div class="step-num">2</div>
        <p><strong>Remplir le champ « Email »</strong> — Cliquez dans le champ <em>Email</em> et saisissez votre adresse email complète.</p>
      </div>
      <div class="step-item">
        <div class="step-num">3</div>
        <p><strong>Remplir le champ « Mot de passe »</strong> — Cliquez dans le champ <em>Mot de passe</em> et tapez votre mot de passe.</p>
      </div>
      <div class="step-item">
        <div class="step-num">4</div>
        <p><strong>Cliquer sur <span class="btn-ref">Connexion</span></strong> — Le système vérifie vos identifiants. Si tout est correct, vous êtes redirigé vers le tableau de bord. Sinon, un message d'erreur s'affiche en rouge.</p>
      </div>
    </div>

    <div class="info-card warning">
      <div class="card-title">
        <span class="material-icons-sharp" style="font-size:16px;color:#ba4f4f">warning</span>
        Première connexion
      </div>
      <p>
        Lors de votre première connexion, le système vous obligera à <strong>changer votre mot de passe par défaut</strong> :<br>
        1. Saisissez votre ancien mot de passe (celui fourni par l'administrateur)<br>
        2. Saisissez votre nouveau mot de passe<br>
        3. Confirmez le nouveau mot de passe<br>
        4. Cliquez sur <strong>Soumettre</strong><br>
        Tant que ce changement n'est pas effectué, vous ne pourrez pas accéder au système.
      </p>
    </div>

    <h3 class="sub-title">Modification du profil</h3>
    <p class="section-text">
      À tout moment, cliquez sur votre nom en haut à droite pour accéder à votre profil.
    </p>
    <ul class="doc-list">
      <li><strong>Nom complet :</strong> Modifiable</li>
      <li><strong>Email :</strong> Non modifiable (identifiant unique)</li>
      <li><strong>Mot de passe :</strong> Saisissez l'ancien puis le nouveau</li>
    </ul>

    <h3 class="sub-title">Déconnexion</h3>
    <p class="section-text">
      Pour vous déconnecter, cliquez sur le bouton <strong>Déconnexion</strong> en bas du menu latéral gauche.
    </p>
  </div>
</template>
<script>
export default { name: "DocConnexion" };
</script>
